/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Nav_FeaturesInputs */

const en_portal_nav_features = /** @type {(inputs: Portal_Nav_FeaturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Features`)
};

const pl_portal_nav_features = /** @type {(inputs: Portal_Nav_FeaturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funkcje`)
};

/**
* | output |
* | --- |
* | "Features" |
*
* @param {Portal_Nav_FeaturesInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_nav_features = /** @type {((inputs?: Portal_Nav_FeaturesInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Nav_FeaturesInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_nav_features(inputs)
	return en_portal_nav_features(inputs)
});